import request from '@/utils/request'
import { encryptedData } from '@/utils/encrypt'
import { loginRSA } from '@/config'

export async function login(data) {
  if (loginRSA) {
    data = await encryptedData(data)
  }
  return request({
    // url: '/api/login',
    url: '/super/login/login',
    method: 'post',
    data,
  })
}
//验证码登录
export async function mobileLogin(data) {
  return request({
    url: '/api/mobileLogin',
    method: 'post',
    data,
  })
}
//发送登录验证码
export async function mobileCode(data) {
  return request({
    url: '/api/sms/login',
    method: 'post',
    data,
  })
}

export async function socialLogin(data) {
  if (loginRSA) {
    data = await encryptedData(data)
  }
  return request({
    url: '/socialLogin',
    method: 'post',
    data,
  })
}

export function getUserInfo() {
  return request({
    url: '/super/user/me',
    method: 'get',
  })
}

export function logout(data) {
  return request({
    url: '/super/Login/logout',
    method: 'post',
    data,
  })
}

export function changePassword(data) {
  return request({
    url: '/super/user/update',
    method: 'post',
    data,
  })
}

export function register(data) {
  return request({
    url: '/register',
    method: 'post',
    data,
  })
}
